import React, { FC } from 'react';
import { TectonDateTimeFormat } from '../../@tecton/ComponentRedesign/utils';
import moment from 'moment';
import { Text } from '@lithos';

const DateCell: FC<{ date: Date | undefined }> = ({ date }) => {
  return <Text size="s">{date ? TectonDateTimeFormat(moment(date)) : 'Not Set'}</Text>;
};

export default DateCell;
